module.exports = __webpack_public_path__ + "media/images/sites/health/garantia-9216043b5d2fcdd2c355c25800fecd41.png";